// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-page__info-blocks[data-v-8d9db824],.main-page__slider[data-v-8d9db824]{margin-bottom:35px}.main-page__wrap[data-v-8d9db824]{display:flex;flex-direction:column;width:100%;max-width:1500px;margin:0 auto}.main-page__scroll-controller[data-v-8d9db824]{margin-top:45px}@media (max-width:800px){.main-page__info-blocks[data-v-8d9db824],.main-page__slider[data-v-8d9db824]{margin-bottom:20px}.main-page__scroll-controller[data-v-8d9db824]{margin-top:35px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
